import { InternalList, IListProps } from './List';

import { Item, IItemProps } from './Item';
import { Meta, IItemMetaProps } from './Meta';

const List = InternalList as any;

List.Item = Item;
List.Item.Meta = Meta;

export type { IListProps, IItemProps, IItemMetaProps };
export { List };
